import React, { useEffect, useState } from 'react'
import { setRichieParam } from '../sfc/component-helpers/utilfunctions'
import { Link } from 'gatsby'

/*
for new pagenave
make an array of linke like
[
  {
    "title": ,
    "url": "
  },
  {
    "title": ,
    "url": "
  },
]
and use setRichieParam
will have to use useeffect and set state like in navtop
*/

export default function Pagenav({ links }) {
  let [navLinks, setNavLinks] = useState(links)

  useEffect(() => {
    let navLinkArray = setRichieParam(links)
    setNavLinks(navLinkArray)
  }, [links])

  return (
    <section
      aria-label="Related links"
      className="latest-news-section top-recirc-section"
    >
      <div className="top-recirc">
        <span className="link">
          <Link to="/" activeClassName={'active'}>
            Vaccine tracker
          </Link>
        </span>

        {navLinks.map((link) => (
          <span key={link.url} className="link">
            <a href={link.url}>{link.text}</a>
          </span>
        ))}
      </div>
    </section>
  )
}
